import { createBrowserRouter, Navigate } from 'react-router'
import AuthCallback from '@/auth/AuthCallback'
import RequireAuth from '@/auth/RequireAuth'
import RequirePool from '@/auth/RequirePool'
import SignInPage from '@/auth/SignInPage'
import AppShell from '@/components/layout/AppShell'
import NotFoundPage from '@/components/layout/NotFoundPage'
import WeekBoardPage from '@/features/board/WeekBoardPage'
import CommissionerPage, {
  CommissionerDashboardLive,
} from '@/features/commissioner/CommissionerPage'
import LedgerPage from '@/features/ledger/LedgerPage'
import PicksPage from '@/features/picks/PicksPage'
import PoolPickerPage from '@/features/pools/PoolPickerPage'
import BoardPage from '@/features/standings/BoardPage'

export const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  // Temporary preview route: renders on mock data, no session required.
  { path: '/dash-preview', element: <CommissionerPage /> },
  {
    element: <RequireAuth />,
    children: [
      { path: '/', element: <Navigate to="/pools" replace /> },
      { path: '/pools', element: <PoolPickerPage /> },
      {
        path: '/p/:poolSlug',
        element: <RequirePool />,
        children: [
          // Outside AppShell deliberately: this is a max-w-5xl page carrying its
          // own header, and AppShell wraps its children in max-w-md under a tab
          // bar. RequirePool supplies the pool context either way.
          { path: 'commissioner', element: <CommissionerDashboardLive /> },
          {
            element: <AppShell />,
            children: [
              { index: true, element: <Navigate to="picks" replace /> },
              { path: 'picks', element: <PicksPage /> },
              { path: 'board', element: <BoardPage /> },
              { path: 'week', element: <WeekBoardPage /> },
              { path: 'ledger', element: <LedgerPage /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])
